import styled from 'styled-components';
import { ValueSet } from '../../../../../../common/model/input/value-sets/types';

import { BouColor } from '../../../../generic/global/bou-colors';
import { defaultMobileBreakpointDEPRECATED } from '../../../../generic/global/styles';
import { OptionProps } from 'react-select';

export interface OptionType {
  value: string;
  label: string;
  description: string;
  valueSet: ValueSet;
}

export const Root = styled.div``;
export const Main = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 18px;
  padding-right: 18px;
  cursor: pointer;
`;

export const Title = styled.div`
  color: ${BouColor.TOOL_TEXT_BLACK};
  font-size: 14px;
  font-weight: 600;
`;

export const Description = styled.div`
  margin-top: 12px;
  color: ${BouColor.TOOL_TEXT_BLACK};
  font-size: 14px;
  line-height: 22px;
  @media (max-width: ${defaultMobileBreakpointDEPRECATED}px) {
    display: none;
  }
`;

function getBackgroundColor(selected: boolean, focused: boolean) {
  if (selected) {
    return BouColor.TOOL_HIGHLIGHT_BRIGHT_YELLOW;
  } else if (focused) {
    return BouColor.TOOL_BUTTON_BACKGROUND_LIGHT;
  }
  return BouColor.TOOL_BACKGROUND_WHITE;
}

export function CustomDropdownOption(props: OptionProps<OptionType, false>) {
  const data = props.data;
  return (
    <Root
      onMouseOver={props.innerProps.onMouseOver}
      onClick={props.innerProps.onClick}
      style={{
        backgroundColor: getBackgroundColor(props.isSelected, props.isFocused),
      }}
    >
      <Main>
        <Title>{data.label}</Title>
        <Description>{data.description}</Description>
      </Main>
    </Root>
  );
}
